import * as React from 'react';
import { CmsImage } from './cms-image/cms-image';
import { getImageURL } from '../util/url/get-image-url.util';
import { ISelectedImage } from '../interface/component/selected-image.interface';
import { getCDNUrl } from '../util/url/get-cdn-url.util';
import { inject, observer } from 'mobx-react';
import { IInjectedProps } from '../interface/component/injected-props.interface';
import { LogoTypeEnum } from '../enum/logo-type.enum';
import { ILogo } from '../interface/block/logo.interface';
import { invariant } from '../util/debug/invariant.util';
import { isDarkColor } from '../util/style/is-dark-color.util';
import { BlockColorType } from '../enum/block-color.enum';
import { ColorType } from '../enum/color.enum';

interface IntelliplanLogoProps {
  backgroundColor?: ColorType | BlockColorType;
  type?: LogoTypeEnum;
  style?: React.CSSProperties;
  label?: string;
  className?: string;
}

@inject('state')
@observer
export class IntelliplanLogo extends React.Component<IntelliplanLogoProps & IInjectedProps> {
  getImageLocation = (image: ISelectedImage) => {
    const imageURL = getImageURL(this.props.state, image, 250);
    return imageURL ? getCDNUrl(this.props.state.configuration, imageURL.location) : undefined;
  }

  render() {
    let logo: ILogo;
    let color: string;
    if (this.props.type) {
      switch (this.props.type) {
        case LogoTypeEnum.WHITE_LOGO:
          logo = this.props.state.logos.white;
          color = this.props.state.colors.White;
          break;
        case LogoTypeEnum.DARK_LOGO:
          logo = this.props.state.logos.dark;
          color = this.props.state.colors.ContentColor;
          break;
      }
    } else if (this.props.backgroundColor) {
      if (isDarkColor(this.props.state.colors.getColor(this.props.backgroundColor))) {
        logo = this.props.state.logos.white;
        color = this.props.state.colors.White;
      } else {
        logo = this.props.state.logos.dark;
        color = this.props.state.colors.ContentColor;
      }
    } else {
      invariant(false, 'You must provide a logo type or a backgroundColor to the logo for it to show properly');
    }
    const logoURL = this.getImageLocation(logo);
    return logoURL ?
      <CmsImage
        useOriginalImage={true}
        alt={logo.title}
        className={this.props.className}
        showLoader={false}
        style={Object.assign({color}, this.props.style)}
        title={this.props.label}
        src={logo}
        maxWidth={250}
        renderAsImg={true}
      /> : null;
  }
}
